// extracted by mini-css-extract-plugin
export default {"cardHeader":"CardHeader_cardHeader__KX01T","borderBottom":"CardHeader_borderBottom__NXm+P"};